import React from "react";
//Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretRight,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

export default function TableHead({
  header,
  tableHeads,
  deleteMonth,
  updateShow,
  show,
}) {
  return (
    <tr>
      <th className="col-2">
        <h3 className="mt-2">
          {header}
          {show && (
            <FontAwesomeIcon
              className="ms-3 black clickable"
              onClick={updateShow}
              icon={faCaretDown}
            />
          )}
          {!show && (
            <FontAwesomeIcon
              className="ms-3 black clickable"
              onClick={updateShow}
              icon={faCaretRight}
            />
          )}
        </h3>
      </th>
      {Object.keys(tableHeads).map((month, i) => {
        if (i === 0) {
          return (
            <th className="">
              <FontAwesomeIcon
                className="black clickable me-2"
                onClick={() => {
                  deleteMonth(i);
                }}
                icon={faTrash}
              />
              {tableHeads[month].slice(0, 3)}
            </th>
          );
        } else {
          return <th className="">{tableHeads[month].slice(0, 3)}</th>;
        }
      })}
      <th></th>
    </tr>
  );
}
